import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: var(--color-overlay);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
`;
